<template>
    <div class="paging">
        <a @click="alterPage(-2)" class="page_link first_page">첫 페이지로 이동</a>
        <a @click="alterPage(-1)" class="page_link prev_page">이전 페이지로 이동</a>
        <a
            v-for="page in totalPages"
            class="page_link"
            :class="{ active: page === currentPage }"
            @click="changePage(page)"
        >{{ page }}</a>
        <a @click="alterPage(1)" class="page_link next_page">다음 페이지로 이동</a>
        <a @click="alterPage(2)" class="page_link last_page">마지막 페이지로 이동</a>
    </div>
</template>
<script>
export default {
    props: {
        currentPage: {
            type: Number,
            required: true
        },
        totalPages: {
            type: Number,
            required: true
        }
    },
    methods: {
    changePage (page) {
      this.$emit("changePage", page)
    },

    async alterPage(trigger) {
      switch(trigger) {
        case -2:
          if (this.currentPage === 1) break;
          this.$emit("changePage", 1)
          break;

        case -1:
        if (this.currentPage === 1) break;
        this.$emit("changePage", this.currentPage - 1)
          break;

        case 1:
        if (this.currentPage === this.totalPages) break;
        this.$emit("changePage", this.currentPage + 1)
          break;

        case 2:
        if (this.currentPage === this.totalPages) break;
        this.$emit("changePage", this.totalPages)
          break;
      }
    }
  }
}
</script>
<style lang="">
    
</style>